import styled from 'styled-components';

const LESS_THAN_870_PX = 'max-width: 870px';

export const Container = styled.div`
  position: relative;
  background-color: #fff;
  border: 1px solid #f1f3f5;
  box-shadow: 0px 4px 4px rgba(173, 181, 189, 0.25);
  border-radius: 3px;
  height: 150px;
  width: 100%;
  margin: 0 20px 20px 0;
  padding: 20px;
  display: flex;

  @media screen and (${LESS_THAN_870_PX}) {
    height: auto;
    padding: 15px;
    width: auto;
    margin: 0 15px 0 15px;
  }
`;

export const LogoBox = styled.div`
  background-color: #fff;
  width: 110px;
  height: 110px;
  border-radius: 110px;
  border: #e9ecef solid 1px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 20px 0 0;
  overflow: hidden;

  @media screen and (${LESS_THAN_870_PX}) {
    display: none;
  }
`;

export const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Title = styled.h1`
  margin: 0;
  padding: 0;
  color: #495057;
  font-size: 18px;
  font-weight: 700;

  @media screen and (${LESS_THAN_870_PX}) {
    font-size: 17px;
  }
`;

export const InformationBox = styled.div`
  height: 110px;
  width: calc(100% - 130px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (${LESS_THAN_870_PX}) {
    width: 100%;
    height: auto;
  }
`;

export const InformationInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ListaZapLink = styled.a`
  padding: 0 2px;
`;

export const NameDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  height: 100%;

  & > h2 {
    margin: 10px 0 0 0;
    padding: 0;
    color: #495057;
    font-size: 14px;
    font-weight: 500;
  }

  @media screen and (${LESS_THAN_870_PX}) {
    & > h2 {
      font-size: 15px;
      margin-top: 5px;
    }
  }
`;

export const LogoBoxInternal = styled.div`
  display: none;

  @media screen and (${LESS_THAN_870_PX}) {
    width: 80px;
    height: 80px;
    border-radius: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 15px 0 0;
    border: #e9ecef solid 1px;
    overflow: hidden;
  }
`;

export const MoreButton = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
`;

export const Footer = styled.div`
  border-top: solid 1px #f1f3f5;
  padding: 20px 0 0 0;
  display: flex;
  user-select: none;

  & img {
    height: 20px;
    width: auto;
    transition: 400ms;
  }

  & span {
    font-size: 15px;
    font-weight: 500;
  }

  & *:not(:first-child) {
    margin-left: 10px;
  }

  @media screen and (${LESS_THAN_870_PX}) {
    margin-top: 15px;
    padding-top: 15px;

    & span {
      font-size: 14px;
    }

    & img {
      height: 18px;
    }
  }
`;
